"use client";

import React from "react";
import { Smartphone, CheckCircle2 } from "lucide-react";

/** Small floating indicator that shows when the app is running as installed PWA */
const PwaModeBadge: React.FC = () => {
  return (
    <div className="fixed bottom-6 right-6 z-[140] print:hidden">
      <div className="flex items-center gap-2 rounded-full border border-primary-main/30 bg-white/90 px-3 py-1.5 shadow-lg shadow-primary-main/15 backdrop-blur-md dark:bg-grayScale-800/90">
        <div className="relative">
          <Smartphone size={14} className="text-primary-main" />
          <CheckCircle2
            size={9}
            className="absolute -bottom-0.5 -right-0.5 rounded-full bg-white text-alert-success-main dark:bg-grayScale-800"
          />
        </div>
        <span className="text-[10px] font-bold text-grayScale-800 dark:text-grayScale-100">
          حالت اپلیکیشن نصب‌شده
        </span>
      </div>
    </div>
  );
};

export default PwaModeBadge;
